// A seagull, modelled facing +X: a white body, grey wings and a yellow beak.
// Ported 1:1 from age-of-mcp's classic seagull.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#f4f6f8",
      position: [0, 0.03, 0], scale: [1.5, 1, 0.9] },                // body
    { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#ffffff",
      position: [0.055, 0.045, 0] },                                 // head
    { geometry: new THREE.ConeGeometry(0.008, 0.026, 4), color: "#f4b400",
      position: [0.082, 0.043, 0], rotation: [0, 0, -Math.PI / 2] },   // beak
    { geometry: new THREE.ConeGeometry(0.018, 0.1, 3), color: "#c4ccd2",
      position: [-0.005, 0.03, 0.06], rotation: [Math.PI / 2, 0, 0], scale: [1, 1, 0.28] },
    { geometry: new THREE.ConeGeometry(0.018, 0.1, 3), color: "#c4ccd2",
      position: [-0.005, 0.03, -0.06], rotation: [-Math.PI / 2, 0, 0], scale: [1, 1, 0.28] },
  ];
}

export const seagull = defineModel({
  id: "seagull",
  batchId: "standard",
  name: "Seagull",
  tags: ["creature","seagull","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly seagull.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => partsFor(),
  animations: [],
});
